import ApiClient from "../api/apiClient";

const ATP = "/atp/activities";
const CPD = "/cpds/";
const GET_ATP_ACTIVIES_COUNT = "/atp/get-atp-activity-status-count";

const getAtpActivities = ({
    page,
    limit,
    cpd_status,
    status,
    search,
    certificate_type,
    registered_from,
    registered_to,
    start_date,
    end_date,
    full_name,
    identity_number,
    technology_field,
    company_name,
    type_of_cpd,
    submission_date,
}) => {
    const baseUrl = `${ATP}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}`;

    // Add optional parameters if present
    if (cpd_status) queryParams += `&cpd_status=${cpd_status}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (search) queryParams += `&search=${search}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (company_name) queryParams += `&company_name=${company_name}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (submission_date) queryParams += `&submission_date=${submission_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getActivityDetailsById = ({ id }) => {
    const url = CPD + id;
    return ApiClient.get(url);
};

const updateATPUserActivityStatus = (data) => {
    return ApiClient.patch(ATP, data);
};

const getAtpActivitiesCounts = ({
    cpd_status,
    status,
    search,
    certificate_type,
    registered_from,
    registered_to,
    start_date,
    end_date,
    full_name,
    identity_number,
    technology_field,
    company_name,
    type_of_cpd,
    submission_date,
}) => {
    const baseUrl = `${GET_ATP_ACTIVIES_COUNT}?`;

    let queryParams = "";

    // Add optional parameters if present
    if (cpd_status) queryParams += `&cpd_status=${cpd_status}`;
    if (start_date) queryParams += `&start_date=${start_date}`;
    if (end_date) queryParams += `&end_date=${end_date}`;
    if (registered_from) queryParams += `&registered_from=${registered_from}`;
    if (registered_to) queryParams += `&registered_to=${registered_to}`;
    if (certificate_type) queryParams += `&certificate_type=${certificate_type}`;
    if (identity_number) queryParams += `&identity_number=${identity_number}`;
    if (search) queryParams += `&search=${search}`;
    if (technology_field) queryParams += `&technology_field=${technology_field}`;
    if (full_name) queryParams += `&full_name=${full_name}`;
    if (company_name) queryParams += `&company_name=${company_name}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (submission_date) queryParams += `&submission_date=${submission_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

export const atpActivitiesService = {
    getAtpActivities,
    getActivityDetailsById,
    updateATPUserActivityStatus,
    getAtpActivitiesCounts,
};
